module.exports = __webpack_public_path__ + "static/media/160421-GlobalNavIA_v5.009.db8cdd1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/misc/160421-GlobalNavIA_v5/160421-GlobalNavIA_v5.009.png
// module id = 203
// module chunks = 0